export function QPanelHitTest() {
  this.fPanelHit = null;
  this.fElementHit = null;
  this.fClickOutside = false;
  this.fClickCmd = null;
  this.fDblClickCmd = null;
  this.fDisabledElementHit = null;
}
